import { render, staticRenderFns } from "./PackingCampaign.vue?vue&type=template&id=1179ddd4&"
import script from "./PackingCampaign.vue?vue&type=script&lang=js&"
export * from "./PackingCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1179ddd4')) {
      api.createRecord('1179ddd4', component.options)
    } else {
      api.reload('1179ddd4', component.options)
    }
    module.hot.accept("./PackingCampaign.vue?vue&type=template&id=1179ddd4&", function () {
      api.rerender('1179ddd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/Editor/Aggregation/PackingCampaign.vue"
export default component.exports